// extracted by mini-css-extract-plugin
module.exports = {"headerItem":"HeaderItem_headerItem__8laMZ","icon":"HeaderItem_icon__2RrTU","text":"HeaderItem_text__ilVq_"};